import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function Home() {
  const benefits = [
    {
      icon: 'ri-gift-line',
      title: 'Free AI Sales Framework',
      description: 'Immediate value, no cost. Get your personalized sales strategy powered by AI.'
    },
    {
      icon: 'ri-settings-3-line',
      title: 'Custom to Your Business',
      description: 'Not generic. Your strategy, your training. Tailored specifically for your industry and goals.'
    },
    {
      icon: 'ri-user-voice-line',
      title: 'Role Play That Sticks',
      description: 'AI-powered practice that makes lessons real. Safe environment to perfect your pitch.'
    },
    {
      icon: 'ri-bar-chart-line',
      title: 'Track Results',
      description: 'Coming soon: dashboards to measure team performance and training effectiveness.'
    }
  ];

  const steps = [
    {
      number: '01',
      title: 'Get your free AI Framework',
      description: 'Receive a customized sales strategy generated specifically for your business needs.'
    },
    {
      number: '02',
      title: 'Refine it with our consultants',
      description: 'Work with our experts to perfect your framework and align it with your goals.'
    },
    {
      number: '03',
      title: 'Train your team with role play',
      description: 'Put your strategy into practice with AI-powered role play sessions that deliver results.'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section 
        className="relative bg-gradient-to-br from-slate-900 via-slate-800 to-teal-900 text-white overflow-hidden"
        style={{
          backgroundImage: `linear-gradient(rgba(15, 23, 42, 0.8), rgba(15, 23, 42, 0.8)), url('https://public.readdy.ai/ai/img_res/2750bc4179b9af4290724f09bc4426ea.jpg')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 lg:py-32">
          <div className="max-w-4xl">
            <h1 className="text-4xl md:text-6xl font-bold leading-tight mb-6">
              The Future of Sales Training: 
              <span className="text-teal-400"> AI-Powered</span>, Custom to Your Business
            </h1>
            <p className="text-xl md:text-2xl text-gray-300 mb-8 max-w-3xl">
              Get a free AI Sales Framework. Then unlock tailored training, real role play, and results you can measure.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <a
                href="https://app.sellsim.co.uk/get-started"
                className="bg-teal-600 text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-teal-700 transition-colors text-center whitespace-nowrap cursor-pointer"
              >
                Get Started
              </a>
              <Link
                to="/contact"
                className="border-2 border-white text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-white hover:text-slate-900 transition-colors text-center whitespace-nowrap cursor-pointer"
              >
                Book a Call
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Key Benefits */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              Why Choose SellSim?
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Revolutionary AI-powered sales training that adapts to your business and delivers measurable results.
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {benefits.map((benefit, index) => (
              <div key={index} className="bg-white p-8 rounded-xl shadow-sm hover:shadow-md transition-shadow">
                <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center mb-6">
                  <i className={`${benefit.icon} text-2xl text-teal-600`}></i>
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-3">
                  {benefit.title}
                </h3>
                <p className="text-gray-600">
                  {benefit.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Social Proof */}
      {/* <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-2xl font-semibold text-gray-900 mb-12">
            Trusted by forward-thinking sales leaders
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-gray-50 p-8 rounded-xl">
              <p className="text-gray-700 mb-4 italic">
                "SellSim transformed our sales approach. The AI framework was spot-on for our industry, and the role play sessions gave our team the confidence they needed."
              </p>
              <div className="font-semibold text-gray-900">Sarah Chen</div>
              <div className="text-gray-600">VP Sales, TechFlow Solutions</div>
            </div>
            <div className="bg-gray-50 p-8 rounded-xl">
              <p className="text-gray-700 mb-4 italic">
                "Finally, sales training that's not one-size-fits-all. The customization level is incredible, and our conversion rates improved by 40%."
              </p>
              <div className="font-semibold text-gray-900">Marcus Rodriguez</div>
              <div className="text-gray-600">Sales Director, Growth Dynamics</div>
            </div>
            <div className="bg-gray-50 p-8 rounded-xl">
              <p className="text-gray-700 mb-4 italic">
                "The role play feature is a game-changer. Our reps practice real scenarios and get instant feedback. It's like having a sales coach available 24/7."
              </p>
              <div className="font-semibold text-gray-900">Jennifer Walsh</div>
              <div className="text-gray-600">Head of Training, Pinnacle Corp</div>
            </div>
          </div>
        </div>
      </section> */}

      {/* Process Steps */}
      <section className="py-20 bg-slate-900 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold mb-4">
              How It Works
            </h2>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
              Three simple steps to transform your sales training and boost your team's performance.
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {steps.map((step, index) => (
              <div key={index} className="text-center">
                <div className="w-16 h-16 bg-teal-600 rounded-full flex items-center justify-center mx-auto mb-6">
                  <span className="text-2xl font-bold">{step.number}</span>
                </div>
                <h3 className="text-xl font-semibold mb-4">
                  {step.title}
                </h3>
                <p className="text-gray-300">
                  {step.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="py-20 bg-teal-600 text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            Start with your free AI sales framework today
          </h2>
          <p className="text-xl mb-8 text-teal-100">
            No commitment required. See how AI can revolutionize your sales strategy in minutes.
          </p>
          <Link
            to="/free-strategy-doc"
            className="bg-white text-teal-600 px-8 py-4 rounded-lg font-semibold text-lg hover:bg-gray-100 transition-colors inline-block whitespace-nowrap cursor-pointer"
          >
            Get Your Free Framework Now
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}
